import { types } from "../actions";

export default (
  state = process.env.REACT_APP_SFDC_LOGIN_URL,
  { type, payload }
) => {
  switch (type) {
    case types.SET_RETURN_URL:
      return payload;
    case types.RESET:
      return process.env.REACT_APP_SFDC_LOGIN_URL;
    default:
      return state;
  }
};
